Vue.component('password-field', {
    data () {
        return {
            type: 'password',

            password: ''
        };
    },

    template: `
        <div class="input-group">
            <input :type="type" class="form-control" v-model="password">
            <div class="input-group-append">
                <div class="input-group-text">
                    <i v-if="type == 'password'" class="fas fa-eye" @click="changeType('text')"></i>
                    <i v-if="type == 'text'" class="fas fa-eye-slash" @click="changeType('password')"></i>
                </div>
            </div>
      </div>
    `,

    mounted () {
        Bus.$on('clearForm', () => {
            this.password = '';
        });
    },

    methods: {
        changeType(type) {
            this.type = type;
        }
    },

    watch: {
        password () {
            this.$emit('on-password-input', this.password);
        }
    }
});